export default class APIOptions {
  url: string;
  T: any;
  // stateValueName: string;
  // stateStatusName: string;
  isPaginated: boolean;
  currentPage: number;
  pageSize: number;
  payload?: any;

  constructor(url: string, T: any, isPaginated: boolean = false, currentPage: number = 1, pageSize: number = 500,
      payload: any = null) {
      this.url = url;
      this.T = T;
      // this.stateValueName = stateValueName;
      // this.stateStatusName = stateStatusName;
      this.isPaginated = isPaginated;
      this.currentPage = currentPage;
      this.pageSize = pageSize;
      this.payload = payload;
  }
}